var $a375bff2c96c1644$exports = {};
const $a375bff2c96c1644$var$form = document.querySelector("#form");
const $a375bff2c96c1644$var$inputs = document.querySelectorAll("#form input, #form select, #form textarea");
if ($a375bff2c96c1644$var$form !== null) $a375bff2c96c1644$var$form.addEventListener("submit", (e)=>{
    e.preventDefault();
    const values = Array.from($a375bff2c96c1644$var$inputs).filter((input)=>input.type != "submit").map((input)=>{
        const label = document.querySelector(`label[for=${input.id}]`)?.textContent;
        return {
            id: input.id,
            value: input.value,
            label: label ? label : null
        };
    });
    alert(values.reduce((accumulator, input)=>accumulator + `${input.label ? input.label : input.id}: ${input.value}\n`, ""));
    console.table(values);
});


//# sourceMappingURL=careers.7da90dcd.js.map
